<template>
    <div>
        <template v-show="isQuestionAllowed">
            <v-btn
            class="mt-0 mx-0"
                color="primary"
                flat
                small
                @click.stop="showModal = true"
            >
                <v-icon>edit</v-icon>
                {{ 'Contact Seller' | translation }}
            </v-btn>
            <v-dialog
                v-model="showModal"
                max-width="500"
            >
                <v-card>
                    <v-card-title>
                        <p class="title">{{productData.name}}</p>
                    </v-card-title>
                    <v-card-text>
                        <v-form
                            ref="merchantContactForm"
                        >
                            <v-container fluid>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                            v-model="firstname"
                                            label="Vorname*"
                                            :messages="showErrors()"
                                            required
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                            v-model="lastname"
                                            label="Nachname*"
                                            required
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                            v-model="email"
                                            label="Email*"
                                            required
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field
                                            v-model="phone"
                                            label="Telefon"
                                        />
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="comment"
                                            label="Nachricht*"
                                            required
                                        />
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="secondary"
                            @click.stop="showModal = false"
                        >
                            {{ 'Abort, stop' | translation }}
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                            color="primary"
                            @click="send"
                        >
                            {{ 'Send request' | translation }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<script>
    import { createNamespacedHelpers } from 'vuex';

    const parentModuleName = 'Product';
    const { mapGetters, mapState, mapActions, mapMutations } = createNamespacedHelpers(parentModuleName);

    export default {
        name: 'ProductContactForm',
        data() {
            return {
                formType: 'question',
                result: this.contactFormResult,
                errors: {},
                success: null,
                showModal: false
            };
        },
        computed: {
            firstname: {
                get() {
                    return this.get('firstname');
                },
                set(value) {
                    this.set('firstname', value);
                }
            },
            lastname: {
                get() {
                    return this.get('lastname');
                },
                set(value) {
                    this.set('lastname', value);
                }
            },
            email: {
                get() {
                    return this.get('email');
                },
                set(value) {
                    this.set('email', value);
                }
            },
            phone: {
                get() {
                    return this.get('phone');
                },
                set(value) {
                    this.set('phone', value);
                }
            },
            comment: {
                get() {
                    return this.get('comment');
                },
                set(value) {
                    this.set('comment', value);
                }
            },
            isQuestionAllowed() {
                let result = false;
                let productId = this.currentProductId;
                let merchantId = this.getCurrentMerchantId;

                if (
                    merchantId &&
                    productId &&
                    this.productData &&
                    this.productData.merchant[merchantId] &&
                    this.productData.merchant[merchantId].productAttributes[productId]
                ) {
                    result = Boolean(
                        this.productData.merchant[merchantId].productAttributes[productId]['mb.questions_to_merchant']
                    );
                }
                return result;
            },
            merchantName() {
                let result = '';
                let merchantId = this.getCurrentMerchantId;
                if (this.productData && this.productData.merchant[merchantId]) {
                    result = this.productData.merchant[merchantId].data.name;
                }

                return result;
            },
            contactForm() {
                return this.isProductBuyable();
            },
            productData() {
                return this.getProduct;
            },
            ...mapState({
                contactFormResult: state => state.contactFormResult
            }),
            ...mapGetters(['getProduct', 'getCurrentMerchantId', 'currentProductId', 'isProductBuyable'])
        },
        methods: {
            ...mapMutations(['updateContactForm', 'clearContactForm']),
            ...mapActions(['sendContactForm']),
            get: function(key) {
                return this.contactForm[key];
            },
            set: function(key, value) {
                this.updateContactForm({
                    property: key,
                    value: value
                });
            },
            send(bvEvt) {
                bvEvt.preventDefault();
                this.sendContactForm({
                    formType: this.formType
                });
            },
            onModalHidden() {
                this.errors = {};
                this.success = null;
                this.clearContactForm();
            },
            resetForm() {
                this.$refs.merchantContactForm.reset();
            },
            showErrors() {
                const vModel = this.model;
                const errors = this.errors;
                for (error in errors[vModel]) {
                    return error;
                }
            }
        },
        watch: {
            contactFormResult(value) {
                let errors = {};
                let success;
                if (value.errors) {
                    Object.keys(value.errors).forEach(field => {
                        errors[field] = [];
                        Object.values(value.errors[field]).forEach(err => errors[field].push(err));
                    });
                }

                success = Boolean(value.result);
                if (value.result !== undefined && success === false && value.message) {
                    errors['general'] = value.message;
                } else if (value.result !== undefined && success === false && Object.values(errors) == 0) {
                    errors['general'] = "Your email can't be sent now. Please try again later.";
                }

                this.success = success;
                this.errors = errors;
            },
            showModal(value) {
                if (!value) {
                    this.resetForm();
                }
            }
        }
    };

</script>